import httpHelper from "@/helpers/httpHelper";
// action types 
export const GET_MONTHLY_REPRT = "getMonthlyReprt";
// mutation types
export const SET_MONTHLY_REPRT = "setMonthlyReprt";

export default {
    state: {
        monthlyReport: [],

    },
    getters: {
        /**
         * Load list of monthly report
         * @param state
         * @returns {*}
         */
        loadedMonthlyReport(state) {
            return state.monthlyReport;
        },


    },
    actions: {
        /**
         * get list of monthly report from api 
         * @param state
         * @param payload
         */
        [GET_MONTHLY_REPRT](context, payload) {
            return new Promise((resolve, reject) => {
                httpHelper
                    .getData('monthly_report')
                    .then((response) => {
                        if (response) {
                            context.commit(SET_MONTHLY_REPRT, response);
                            resolve(response);
                        } else {
                            this.$makeToast('danger','error',"server not respons for get notifications.",5000)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                    })
                    .finally(() => { });
            });
        },
    },
    mutations: {

        [SET_MONTHLY_REPRT](state, payload) {
            state.monthlyReport = payload;
        },

    }
};